import Validators from '../validators'

export default (store) => store.createEmbededEntityState({
  attrs: ['person_id', 'role_id', 'role_order'],
  noSort: ['person_id', 'role_id', 'role_order'],
  titles: [store.__('person'), store.__('role'), store.__('order')],
  _sortField: 'role_order',
  initVals: (row) => ({
    role_order: (!store.cv.record.get('roles') ? 1 : store.cv.record.get('roles').length + 1)
  }),
  validators: {
    person_id: Validators.isMandatory(store),
    role_id: Validators.isMandatory(store),
    role_order: Validators.positiveInt(store),
    _global: (vals, items) => {
      store.cv.record.get('roles') && store.cv.record.get('roles').map((v, k) => {
        if (!v.role_order) {
          v.role_order = k + 1
        }
      })
    }
  }
})
